import { render, staticRenderFns } from "./BeeNumericField.vue?vue&type=template&id=54b87d81"
import script from "./BeeNumericField.vue?vue&type=script&lang=js"
export * from "./BeeNumericField.vue?vue&type=script&lang=js"
import style0 from "./BeeNumericField.vue?vue&type=style&index=0&id=54b87d81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports